import axios from 'axios';

const assignmentAssignToApi = axios.create({
    baseURL: process.env.REACT_APP_IEQIP_CORE_SERVICE_API_URL
});

export default assignmentAssignToApi;